import React from 'react'
import styles from './PatientCategoryTab.module.css'

class PatientCategoryTab extends React.Component {

    render() {
        return (
            <div
                className={(this.props.selected === true ? styles.category_tab_selected : styles.category_tab)}
                onClick={() => this.props.changeCategory({ptno: this.props.ptno, selectedHomeCategory: this.props.categoryId})}>
                {this.props.name}
            </div>
        );
    }
}

export { PatientCategoryTab };
